import _objectSpread from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import { isEmpty } from "@/utils/shared";
import * as echarts from "echarts";
export default {
  name: "MedicalInsuranceDivision",
  props: ["source", "id"],
  data: function data() {
    return {
      legends: [{
        name: "职工医保",
        value: 1,
        key: "weekNum"
      }, {
        name: "新农合医保",
        value: 1,
        key: "monthNum"
      }, {
        name: "城镇居民基本医保",
        value: 1,
        key: "threeNum"
      }, {
        name: "离休干部医保",
        value: 1,
        key: "yearNum"
      }],
      echart: null,
      idx: 0,
      timer: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.init();
    this.timer = setInterval(function () {
      if (_this.echart) {
        _this.echart.dispatchAction({
          type: "downplay",
          dataIndex: _this.idx
        });
        _this.idx++;
        if (_this.idx > 3) {
          _this.idx = 0;
        }
        _this.echart.dispatchAction({
          type: "highlight",
          dataIndex: _this.idx
        });
      }
    }, 2000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  watch: {
    source: function source() {
      this.init();
    },
    id: function id() {
      this.echart && this.echart.resize();
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;
      if (isEmpty(this.echart)) {
        this.echart = echarts.init(document.getElementById("MIDivision"));
      }
      var echart = this.echart;
      echart.setOption({
        color: ["#578BFF", "#DEA60F", "#09E1F8", "#0BDD8C"],
        series: {
          name: "Nightingale Chart",
          type: "pie",
          radius: ["45%", "70%"],
          center: ["50%", "50%"],
          label: {
            show: false
          },
          data: this.legends.map(function (it) {
            return _objectSpread(_objectSpread({}, it), {}, {
              value: _this2.source[it.key] || 0
            });
          })
        }
      });
    },
    size: function size(sz) {
      return sz / 14 * document.documentElement.style.fontSize.slice(0, -2);
    }
  }
};